<template lang="pug">
  .middle-box.text-center.loginscreen.animated.fadeInDown
    div
      div
        h2 Loging Out
        h4 Please wait...
</template>

<script>
  import axios from 'axios'
  
  export default {
    mounted () {
      axios.defaults.headers.common['Authorization'] = ''
      this.$ls.clear()
      this.$router.push('/login')
    }
  }
</script>

<style lang="less">
  h2, h4 {
    color: white;
  }
</style>




// WEBPACK FOOTER //
// logout.vue?23a6f048